import React from 'react';
import { Link } from 'react-router-dom';
import { SuperCardType } from './types';
import { format } from 'date-fns';

import {
  RiCalendarEventLine,
  RiCalendarTodoLine,
  RiPencilRuler2Line,
  RiVerifiedBadgeLine,
} from 'react-icons/ri';
// import { TbProgress } from 'react-icons/tb';

// import { RiToolsFill } from 'react-icons/ri';
import classNames from 'classnames';

const SuperCard = (props: SuperCardType) => {
  const allSkills: any[] = [];

  props.tasks.forEach((task: any) => {
    task.skillId.forEach((skill: any) => {
      if (
        skill &&
        !allSkills.some((someSkill: any) => someSkill._id === skill._id)
      ) {
        allSkills.push(skill);
      }
    });
  });

  const taskLength = props.tasks.length;
  const totalTasks = props?.tasks?.length;
  const submittedTasks = props?.capstoneSubmissions
    ? props.capstoneSubmissions.length
    : 0;

  const progressPercentage = ((submittedTasks * 100) / totalTasks).toFixed(2);
  const progressPercentageNumber = +progressPercentage;

  // New conditions to render right side of SuperCard
  const allRight = !props.capstoneSubmissions;

  const onGoingRight =
    props?.capstoneSubmissions &&
    progressPercentageNumber >= 0 &&
    progressPercentageNumber < 100;

  const completedRight = progressPercentageNumber === 100;

  const downloadCertificateSatisfy =
    progressPercentageNumber === 100 &&
    props?.capstoneAssessments?.percentage >= 50;

  const isCapstoneSubmitted =
    props.capstoneSubmissions && props.capstoneSubmissions.length > 0;

  const lastUpdatedDate = isCapstoneSubmitted
    ? props.capstoneSubmissions[props.capstoneSubmissions.length - 1]
        ?.lastUpdated
    : undefined;

  const totalTime =
    props.tasks && props.tasks.length
      ? props.tasks?.map((i: any) => i.time).reduce((a: any, b: any) => a + b)
      : 0;

  return (
    <Link
      key={props._id}
      to={
        props.capStatus === 'completed'
          ? `/supercapstone/${props._id}/tasks`
          : '/supercapstone/' + props._id
      }
      className='border-2   border-gray-200 rounded-lg flex flex-col md:flex-row p-2 sm:p-0'>
      {/* image,heading and text+icons under heading start here */}
      <div className='p-2 md:p-5 md:border-r-2 border-gray-200 flex justify-center md:basis-2/12'>
        <img
          className='h-12 md:h-32 object-contain'
          src={props.logo}
          alt={`${props.title} Logo`}
        />
      </div>
      <div className='p-2 md:p-5 md:border-r-2 flex flex-col justify-between gap-3  md:basis-6/12'>
        <div className='flex flex-col gap-2'>
          <span className='font-bold text-lg'>{props.title}</span>
          <div className='flex  flex-wrap gap-x-6 gap-y-1'>
            <div className='flex items-center flex-row gap-1 text-sm'>
              <svg
                width='16'
                height='17'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M4.15672 4.80211C3.234 5.76091 2.66666 7.06416 2.66666 8.49992C2.66666 11.4455 5.05447 13.8333 7.99999 13.8333C8.72053 13.8333 9.40773 13.6904 10.0347 13.4314C10.1114 12.9311 9.94319 12.451 9.87439 12.283C9.72133 11.9099 9.21606 11.2721 8.37259 10.3871C8.14746 10.1505 8.16193 9.96892 8.24239 9.42945L8.25166 9.36852C8.30633 8.99899 8.39806 8.78052 9.64146 8.58312C10.2731 8.48298 10.4393 8.73545 10.6695 9.08505C10.695 9.12378 10.7205 9.16178 10.7465 9.19985C10.9653 9.51972 11.1273 9.59285 11.3721 9.70419C11.4818 9.75392 11.6187 9.81665 11.8021 9.92085C12.2367 10.1693 12.2367 10.4497 12.2367 11.0647V11.1345C12.2367 11.3955 12.2112 11.6247 12.1711 11.8239C12.8985 10.9123 13.3333 9.75685 13.3333 8.49992C13.3333 6.30051 12.002 4.41205 10.1013 3.59647C9.73246 3.84534 9.22653 4.19809 9.04999 4.43992C8.95973 4.5635 8.83213 5.19436 8.41713 5.24643C8.30839 5.26007 8.16253 5.25051 8.00799 5.24057C7.59366 5.21364 7.02679 5.17729 6.84533 5.66989C6.73013 5.98205 6.70986 6.82955 7.08259 7.26945C7.14226 7.33972 7.15379 7.46972 7.11326 7.61558C7.05999 7.80712 6.95239 7.92365 6.91886 7.94772C6.85459 7.91078 6.72639 7.76199 6.63958 7.66072C6.43035 7.41759 6.16936 7.11481 5.83197 7.02109C5.70929 6.98714 5.57443 6.95903 5.44365 6.93149C5.07759 6.85476 4.66295 6.76748 4.56661 6.56193C4.49627 6.41139 4.49658 6.20406 4.49685 5.98501C4.49685 5.70739 4.49685 5.39345 4.36085 5.08829C4.3083 4.97019 4.23792 4.87622 4.15672 4.80211ZM7.99999 15.1666C4.31809 15.1666 1.33333 12.1818 1.33333 8.49992C1.33333 4.81802 4.31809 1.83325 7.99999 1.83325C11.6819 1.83325 14.6667 4.81802 14.6667 8.49992C14.6667 12.1818 11.6819 15.1666 7.99999 15.1666Z'
                  fill='#10ABB7'
                />
              </svg>

              {props.country}
            </div>
            {props.industry && (
              <div className='flex items-center flex-row gap-1 text-sm'>
                <svg
                  width='16'
                  height='17'
                  viewBox='0 0 16 17'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M3.55295 2.68097C4.37501 2.38872 5.3282 2.57158 5.98618 3.22956C6.73347 3.97683 6.86793 5.10486 6.38953 5.98914L13.5287 13.129L12.5859 14.0719L5.44655 6.93242C4.56217 7.41116 3.43379 7.27682 2.68635 6.52939C2.02818 5.87123 1.8454 4.91768 2.13801 4.09546L3.62915 5.58658C4.01968 5.9771 4.65285 5.9771 5.04337 5.58658C5.43389 5.19606 5.43389 4.56289 5.04337 4.17237L3.55295 2.68097ZM10.4645 3.93666L12.5859 2.75815L13.5287 3.70096L12.3501 5.82228L11.1716 6.05798L9.7574 7.47222L8.8146 6.52939L10.2288 5.11518L10.4645 3.93666ZM5.98618 9.35783L6.929 10.3006L3.39345 13.8362C3.13311 14.0965 2.71099 14.0965 2.45065 13.8362C2.20889 13.5944 2.19163 13.2132 2.39884 12.9515L2.45065 12.8934L5.98618 9.35783Z'
                    fill='#10ABB7'
                  />
                </svg>

                {props.industry}
              </div>
            )}
            <div className='flex items-center  flex-row gap-1 text-sm'>
              <svg
                width='16'
                height='17'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M4.66665 3.83341V1.83341C4.66665 1.46523 4.96513 1.16675 5.33331 1.16675H10.6666C11.0348 1.16675 11.3333 1.46523 11.3333 1.83341V3.83341H14C14.3682 3.83341 14.6666 4.13189 14.6666 4.50008V13.8334C14.6666 14.2016 14.3682 14.5001 14 14.5001H1.99998C1.63179 14.5001 1.33331 14.2016 1.33331 13.8334V4.50008C1.33331 4.13189 1.63179 3.83341 1.99998 3.83341H4.66665ZM2.66665 11.1667V13.1667H13.3333V11.1667H2.66665ZM2.66665 9.83341H13.3333V5.16675H2.66665V9.83341ZM5.99998 2.50008V3.83341H9.99998V2.50008H5.99998ZM7.33331 7.83341H8.66665V9.16675H7.33331V7.83341Z'
                  fill='#10ABB7'
                />
              </svg>

              {props.domain}
            </div>
            <div className='flex items-center flex-row gap-1 text-sm'>
              <svg
                width='16'
                height='17'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M13.3334 15.1667H12V13.8334C12 12.7288 11.1046 11.8334 10 11.8334H6.00002C4.89545 11.8334 4.00002 12.7288 4.00002 13.8334V15.1667H2.66669V13.8334C2.66669 11.9925 4.15907 10.5001 6.00002 10.5001H10C11.841 10.5001 13.3334 11.9925 13.3334 13.8334V15.1667ZM8.00002 9.16675C5.79088 9.16675 4.00002 7.37588 4.00002 5.16675C4.00002 2.95761 5.79088 1.16675 8.00002 1.16675C10.2092 1.16675 12 2.95761 12 5.16675C12 7.37588 10.2092 9.16675 8.00002 9.16675ZM8.00002 7.83342C9.47275 7.83342 10.6667 6.63951 10.6667 5.16675C10.6667 3.69399 9.47275 2.50008 8.00002 2.50008C6.52726 2.50008 5.33335 3.69399 5.33335 5.16675C5.33335 6.63951 6.52726 7.83342 8.00002 7.83342Z'
                  fill='#10ABB7'
                />
              </svg>

              {props.level}
            </div>
            <div className='flex items-center flex-row gap-1 text-sm'>
              <svg
                width='16'
                height='17'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M7.99998 15.1666C4.31808 15.1666 1.33331 12.1818 1.33331 8.49992C1.33331 4.81802 4.31808 1.83325 7.99998 1.83325C11.6818 1.83325 14.6666 4.81802 14.6666 8.49992C14.6666 12.1818 11.6818 15.1666 7.99998 15.1666ZM7.99998 13.8333C10.9455 13.8333 13.3333 11.4455 13.3333 8.49992C13.3333 5.5544 10.9455 3.16659 7.99998 3.16659C5.05446 3.16659 2.66665 5.5544 2.66665 8.49992C2.66665 11.4455 5.05446 13.8333 7.99998 13.8333ZM8.66665 8.49992H11.3333V9.83325H7.33331V5.16658H8.66665V8.49992Z'
                  fill='#10ABB7'
                />
              </svg>
              {totalTime} hours
            </div>
          </div>
        </div>
        <div className='flex flex-wrap gap-1'>
          {allSkills.map((skill, idx) => (
            <span
              key={idx}
              className='rounded-2xl border-[1px] border-gray-200 py-2 px-4 text-xs bg-[#F6FEFE]  text-center'>
              {skill.title}
            </span>
          ))}
        </div>
      </div>
      {/* right side */}
      {false && allRight && (
        <div className='flex items-end my-4 justify-center px-2 md:px-6 md:basis-4/12'>
          <button className='bg-primary w-full text-white px-6 py-2 rounded-md'>
            View Details
          </button>
        </div>
      )}
      {false && onGoingRight && (
        <div className='my-4 md:my-auto px-2 md:px-6 space-y-4   md:basis-4/12'>
          <div className='grid grid-cols-2 grid-rows-2 gap-2 md:gap-6 '>
            {/* date */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5.99992 1.16675V2.50008H9.99992V1.16675H11.3333V2.50008H13.9999C14.3681 2.50008 14.6666 2.79856 14.6666 3.16675V13.8334C14.6666 14.2016 14.3681 14.5001 13.9999 14.5001H1.99992C1.63173 14.5001 1.33325 14.2016 1.33325 13.8334V3.16675C1.33325 2.79856 1.63173 2.50008 1.99992 2.50008H4.66658V1.16675H5.99992ZM13.3333 7.83341H2.66659V13.1667H13.3333V7.83341ZM7.33325 9.16675V11.8334H3.99992V9.16675H7.33325ZM4.66658 3.83341H2.66659V6.50008H13.3333V3.83341H11.3333V5.16675H9.99992V3.83341H5.99992V5.16675H4.66658V3.83341Z'
                  fill='#10ABB7'
                />
              </svg>
              <p className='text-sm md:text-base'>
                {format(new Date(props?.createdAt), 'do LLLL yyyy')}
              </p>
            </div>
            {/* progress */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M7.33319 1.86621L7.33325 3.20788C4.70239 3.53593 2.66659 5.7802 2.66659 8.49996C2.66659 11.4455 5.0544 13.8333 7.99992 13.8333C9.23239 13.8333 10.3672 13.4152 11.2703 12.7132L12.2192 13.6618C11.0699 14.6024 9.60085 15.1666 7.99992 15.1666C4.31802 15.1666 1.33325 12.1818 1.33325 8.49996C1.33325 5.04308 3.96433 2.20072 7.33319 1.86621ZM14.6337 9.16669C14.5005 10.5074 13.9703 11.7312 13.1621 12.7188L12.2132 11.7703C12.7867 11.0326 13.1706 10.1404 13.292 9.16656L14.6337 9.16669ZM8.66732 1.86628C11.8166 2.1793 14.3209 4.68388 14.6337 7.83322L13.292 7.83329C12.9912 5.42104 11.0794 3.50905 8.66725 3.20796L8.66732 1.86628Z'
                  fill='#10ABB7'
                />
              </svg>

              <p>
                {progressPercentageNumber === 0 ? (
                  <span>0%</span>
                ) : (
                  <span>{progressPercentageNumber}%</span>
                )}
              </p>
            </div>
            {/* day */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5.99992 1.16675V2.50008H9.99992V1.16675H11.3333V2.50008H13.9999C14.3681 2.50008 14.6666 2.79856 14.6666 3.16675V13.8334C14.6666 14.2016 14.3681 14.5001 13.9999 14.5001H1.99992C1.63173 14.5001 1.33325 14.2016 1.33325 13.8334V3.16675C1.33325 2.79856 1.63173 2.50008 1.99992 2.50008H4.66658V1.16675H5.99992ZM13.3333 7.83341H2.66659V13.1667H13.3333V7.83341ZM5.33325 9.83341V11.1667H3.99992V9.83341H5.33325ZM11.9999 9.83341V11.1667H6.66658V9.83341H11.9999ZM4.66658 3.83341H2.66659V6.50008H13.3333V3.83341H11.3333V5.16675H9.99992V3.83341H5.99992V5.16675H4.66658V3.83341Z'
                  fill='#10ABB7'
                />
              </svg>

              <p className='text-sm md:text-base'>Day - </p>
            </div>
            {/* tasks */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M4.7003 9.91416L3.28608 11.3284L5.1717 13.214L12.7141 5.67154L10.8285 3.78592L9.41435 5.20013L10.3571 6.14295L9.41435 7.08575L8.47155 6.14295L7.52875 7.08575L8.47155 8.02856L7.52875 8.97136L6.58591 8.02856L5.64311 8.97136L6.58591 9.91416L5.64311 10.857L4.7003 9.91416ZM11.2999 2.37171L14.1284 5.20013C14.3887 5.46049 14.3887 5.88259 14.1284 6.14295L5.64311 14.6282C5.38275 14.8886 4.96065 14.8886 4.7003 14.6282L1.87187 11.7998C1.61152 11.5394 1.61152 11.1174 1.87187 10.857L10.3571 2.37171C10.6175 2.11136 11.0396 2.11136 11.2999 2.37171ZM9.41435 12.7423L10.3571 11.7995L11.8521 13.2945H12.7949V12.3517L11.2999 10.8567L12.2427 9.91383L13.9999 11.671V14.4999H11.1719L9.41435 12.7423ZM3.75739 7.08533L1.87177 5.19971C1.61143 4.93937 1.61143 4.51725 1.87177 4.25691L3.75739 2.37129C4.01774 2.11094 4.43985 2.11094 4.7002 2.37129L6.58582 4.25691L5.64301 5.19971L4.2288 3.7855L3.28599 4.72831L4.7002 6.14253L3.75739 7.08533Z'
                  fill='#10ABB7'
                />
              </svg>

              <p className='text-sm md:text-base'>
                {submittedTasks}/{taskLength} Tasks{' '}
              </p>
            </div>
          </div>
          {/* button */}
          <button className='bg-primary w-full text-white px-6 py-2 rounded-md'>
            Continue Task {submittedTasks + 1}
          </button>
        </div>
      )}
      {false && completedRight && (
        <div className='my-4 md:my-auto px-2 md:px-6 space-y-4   md:basis-4/12'>
          <div className='grid grid-cols-2 grid-rows-2 gap-2 md:gap-6 '>
            {/* start date */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5.99992 1.16675V2.50008H9.99992V1.16675H11.3333V2.50008H13.9999C14.3681 2.50008 14.6666 2.79856 14.6666 3.16675V13.8334C14.6666 14.2016 14.3681 14.5001 13.9999 14.5001H1.99992C1.63173 14.5001 1.33325 14.2016 1.33325 13.8334V3.16675C1.33325 2.79856 1.63173 2.50008 1.99992 2.50008H4.66658V1.16675H5.99992ZM13.3333 7.83341H2.66659V13.1667H13.3333V7.83341ZM7.33325 9.16675V11.8334H3.99992V9.16675H7.33325ZM4.66658 3.83341H2.66659V6.50008H13.3333V3.83341H11.3333V5.16675H9.99992V3.83341H5.99992V5.16675H4.66658V3.83341Z'
                  fill='#10ABB7'
                />
              </svg>
              <p className='text-sm md:text-base'>
                {format(new Date(props?.createdAt), 'do LLLL yyyy')}
              </p>
            </div>
            {/* progress */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M6.67154 1.90243C5.73712 1.59995 4.72137 2.02069 4.27454 2.89529L3.73735 3.94674C3.67353 4.07167 3.57191 4.17328 3.44699 4.23711L2.39553 4.77429C1.52093 5.22113 1.1002 6.23688 1.40267 7.17127L1.76631 8.2946C1.80952 8.42807 1.80952 8.5718 1.76631 8.70527L1.40267 9.8286C1.1002 10.763 1.52094 11.7787 2.39553 12.2255L3.44699 12.7627C3.57191 12.8266 3.67353 12.9282 3.73735 13.0531L4.27454 14.1045C4.72137 14.9791 5.73713 15.3999 6.67154 15.0974L7.79487 14.7338C7.92833 14.6906 8.072 14.6906 8.20547 14.7338L9.3288 15.0974C10.2632 15.3999 11.279 14.9791 11.7258 14.1045L12.263 13.0531C12.3268 12.9282 12.4284 12.8266 12.5533 12.7627L13.6048 12.2255C14.4794 11.7787 14.9001 10.763 14.5977 9.8286L14.234 8.70527C14.1908 8.5718 14.1908 8.42807 14.234 8.2946L14.5977 7.17127C14.9001 6.23687 14.4794 5.22113 13.6048 4.77429L12.5533 4.23711C12.4284 4.17328 12.3268 4.07167 12.263 3.94674L11.7258 2.89529C11.279 2.02069 10.2632 1.59995 9.3288 1.90243L8.20547 2.26607C8.072 2.30927 7.92833 2.30927 7.79487 2.26607L6.67154 1.90243ZM5.46189 3.50191C5.61083 3.21037 5.94941 3.07013 6.26088 3.17095L7.3842 3.53459C7.7846 3.66421 8.21573 3.66421 8.61613 3.53459L9.73947 3.17095C10.0509 3.07013 10.3895 3.21037 10.5385 3.50191L11.0757 4.55336C11.2671 4.92815 11.5719 5.23297 11.9467 5.42445L12.9982 5.96164C13.2897 6.11059 13.43 6.44917 13.3291 6.76063L12.9655 7.884C12.8359 8.2844 12.8359 8.71547 12.9655 9.11587L13.3291 10.2392C13.43 10.5507 13.2897 10.8893 12.9982 11.0382L11.9467 11.5754C11.5719 11.7669 11.2671 12.0717 11.0757 12.4465L10.5385 13.4979C10.3895 13.7895 10.0509 13.9297 9.73947 13.8289L8.61613 13.4653C8.21573 13.3357 7.7846 13.3357 7.3842 13.4653L6.26088 13.8289C5.94941 13.9297 5.61083 13.7895 5.46189 13.4979L4.9247 12.4465C4.73322 12.0717 4.42839 11.7669 4.05361 11.5754L3.00215 11.0382C2.71062 10.8893 2.57037 10.5507 2.6712 10.2392L3.03484 9.11587C3.16445 8.71547 3.16445 8.2844 3.03484 7.884L2.6712 6.76063C2.57037 6.44917 2.71062 6.11059 3.00215 5.96164L4.0536 5.42445C4.42839 5.23297 4.73322 4.92815 4.9247 4.55336L5.46189 3.50191ZM4.50656 8.3382L7.335 11.1666L12.0491 6.45257L11.1063 5.50976L7.335 9.281L5.44937 7.39533L4.50656 8.3382Z'
                  fill='#10ABB7'
                />
              </svg>

              <p>{progressPercentageNumber}%</p>
            </div>
            {/* final task submit date */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M5.99992 1.16675V2.50008H9.99992V1.16675H11.3333V2.50008H13.9999C14.3681 2.50008 14.6666 2.79856 14.6666 3.16675V13.8334C14.6666 14.2016 14.3681 14.5001 13.9999 14.5001H1.99992C1.63173 14.5001 1.33325 14.2016 1.33325 13.8334V3.16675C1.33325 2.79856 1.63173 2.50008 1.99992 2.50008H4.66658V1.16675H5.99992ZM13.3333 7.16675H2.66659V13.1667H13.3333V7.16675ZM10.0236 7.92408L10.9664 8.86695L7.66658 12.1667L5.30957 9.80975L6.25237 8.86695L7.66658 10.2811L10.0236 7.92408ZM4.66658 3.83341H2.66659V5.83341H13.3333V3.83341H11.3333V4.50008H9.99992V3.83341H5.99992V4.50008H4.66658V3.83341Z'
                  fill='#10ABB7'
                />
              </svg>
              <p className='text-sm md:text-base'>
                {format(new Date(lastUpdatedDate), 'do LLLL yyyy')}
              </p>{' '}
            </div>
            {/* tasks */}
            <div className='flex space-x-2 items-center'>
              <svg
                width='25'
                height='24'
                viewBox='0 0 16 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M4.7003 9.91416L3.28608 11.3284L5.1717 13.214L12.7141 5.67154L10.8285 3.78592L9.41435 5.20013L10.3571 6.14295L9.41435 7.08575L8.47155 6.14295L7.52875 7.08575L8.47155 8.02856L7.52875 8.97136L6.58591 8.02856L5.64311 8.97136L6.58591 9.91416L5.64311 10.857L4.7003 9.91416ZM11.2999 2.37171L14.1284 5.20013C14.3887 5.46049 14.3887 5.88259 14.1284 6.14295L5.64311 14.6282C5.38275 14.8886 4.96065 14.8886 4.7003 14.6282L1.87187 11.7998C1.61152 11.5394 1.61152 11.1174 1.87187 10.857L10.3571 2.37171C10.6175 2.11136 11.0396 2.11136 11.2999 2.37171ZM9.41435 12.7423L10.3571 11.7995L11.8521 13.2945H12.7949V12.3517L11.2999 10.8567L12.2427 9.91383L13.9999 11.671V14.4999H11.1719L9.41435 12.7423ZM3.75739 7.08533L1.87177 5.19971C1.61143 4.93937 1.61143 4.51725 1.87177 4.25691L3.75739 2.37129C4.01774 2.11094 4.43985 2.11094 4.7002 2.37129L6.58582 4.25691L5.64301 5.19971L4.2288 3.7855L3.28599 4.72831L4.7002 6.14253L3.75739 7.08533Z'
                  fill='#10ABB7'
                />
              </svg>

              <p className='text-sm md:text-base'>
                {submittedTasks}/{taskLength} Tasks{' '}
              </p>
            </div>
          </div>
          {/* button */}
          <button
            disabled={!downloadCertificateSatisfy}
            className={classNames(
              'bg-primary w-full text-white px-6 py-2 rounded-md',
              {
                'opacity-50': !downloadCertificateSatisfy,
                'opacity-100': downloadCertificateSatisfy,
              }
            )}>
            Download Certificate
          </button>
        </div>
      )}
      <div
        className={`flex flex-col my-4 px-2 md:px-6 md:basis-4/12 ${
          props.capStatus === 'all' ? 'justify-end' : 'justify-between'
        }`}>
        {props.capStatus !== 'all' && (
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row justify-between'>
              <div className='flex gap-2 items-center justify-start w-full'>
                <RiCalendarEventLine className='text-primary text-2xl' />
                <span className='text-lg'>
                  {format(props.buttonData.date, 'do LLLL yyyy')}
                </span>
              </div>
              <div className='flex gap-2 items-center justify-start w-full'>
                {props.capStatus === 'ongoing' && (
                  <React.Fragment>
                    <svg
                      width='25'
                      height='24'
                      viewBox='0 0 16 17'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M7.33319 1.86621L7.33325 3.20788C4.70239 3.53593 2.66659 5.7802 2.66659 8.49996C2.66659 11.4455 5.0544 13.8333 7.99992 13.8333C9.23239 13.8333 10.3672 13.4152 11.2703 12.7132L12.2192 13.6618C11.0699 14.6024 9.60085 15.1666 7.99992 15.1666C4.31802 15.1666 1.33325 12.1818 1.33325 8.49996C1.33325 5.04308 3.96433 2.20072 7.33319 1.86621ZM14.6337 9.16669C14.5005 10.5074 13.9703 11.7312 13.1621 12.7188L12.2132 11.7703C12.7867 11.0326 13.1706 10.1404 13.292 9.16656L14.6337 9.16669ZM8.66732 1.86628C11.8166 2.1793 14.3209 4.68388 14.6337 7.83322L13.292 7.83329C12.9912 5.42104 11.0794 3.50905 8.66725 3.20796L8.66732 1.86628Z'
                        fill='#10ABB7'
                      />
                    </svg>
                    <span className='text-lg'>
                      {props.buttonData.progress} %
                    </span>
                  </React.Fragment>
                )}
                {props.capStatus === 'completed' && (
                  <React.Fragment>
                    <RiVerifiedBadgeLine className='text-primary text-2xl' />
                    <span className='text-lg'>
                      {props.buttonData.progress} %
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className='flex flex-row justify-between'>
              <div className='flex gap-2 items-center justify-start w-full'>
                <RiCalendarTodoLine className='text-primary text-2xl' />
                <span className='text-lg'>
                  {`Day ${props.buttonData.dayCount}`}
                </span>
              </div>
              <div className='flex gap-2 items-center justify-start w-full'>
                <RiPencilRuler2Line className='text-primary text-2xl' />
                <span className='text-lg'>{props.buttonData.tasksDoneStr}</span>
              </div>
            </div>
          </div>
        )}
        <div className='flex flex-col gap-2 text-center'>
        <button className='bg-primary w-full text-white px-6 py-2 rounded-md'>
          {props.buttonText}
        </button>
        {props.capStatus === 'all' && (
          <p className='text-sm text-red-500'>Limited seats</p>
        )}
        </div>
        
      </div>
    </Link>
  );
};

export default SuperCard;
